import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { environment } from 'src/environments/environment';
import { ConfigService } from '../config.service';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor(private configService: ConfigService) {}

  async handleError(error) {
    await this.configService.loadConfig();
    const sentryUrl = this.configService.getSentryUrl();
    if (sentryUrl) {
      Sentry.captureException(error.originalError || error);
    }
  }
}

export function getErrorHandler(): ErrorHandler {
  if (environment.production) {
    return new SentryErrorHandler(new ConfigService());
  }
  return new ErrorHandler();
}
